<template>
    <div>
        <PesquisaPacienteModal
            v-if="modalSelecionarPaciente"
            v-model="modalSelecionarPaciente"
            @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
            @confirmarPacienteSelecionado="selecionarPaciente"
        />
        <PesquisaDentistaModal
            v-if="modalSelecionarDentista"
            v-model="modalSelecionarDentista"
            @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
            @confirmarDentistaSelecionado="selecionarDentista"
        />
        <v-dialog
            v-model="model"
            scrollable
            @click:outside="fecharModalOutsideClick"
            :persistent="persistencia"
            :max-width="maxWidth"
            style="padding: 0">
            <v-card class="card-component rounded-lg overflow-hidden">
                <v-toolbar dark color="primary" elevation="2">
                    <v-icon left>mdi-calendar-plus</v-icon>
                    <v-toolbar-title class="font-weight-bold">Adicionar evento
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn class="close__button" text @click="fecharModal" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text style="color: black" class="pa-6">
                    <v-container fluid class="pa-0">
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <v-textarea
                                    v-model="dadosGerais.descricao"
                                    name="descricao"
                                    label="Descrição"
                                    placeholder="Informe a descrição do evento"
                                    outlined
                                    auto-grow
                                    counter="250"
                                    maxlength="250"
                                    prepend-inner-icon="mdi-text-subject"
                                    v-validate="{required: true, min: 5, max: 250}"
                                    :error-messages="errors.collect('descricao')">
                                    <template v-slot:label>
                                        Descrição
                                        <span class="ml-1 red--text">*</span>
                                    </template>
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-2">
                                <date-input-evento
                                    v-model="dadosGerais.dataInicio"
                                    :data-fim="dadosGerais.dataFim"
                                    @selecionarDuracao="atualizarDuracaoEvento"
                                    @atualizarData="atualizarData"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-2">
                                <v-btn v-if="!pacienteSelecionado" depressed block large color="primary"
                                       class="rounded-pill"
                                       @click="abrirModalSelecionarPaciente">
                                    <v-icon left>mdi-account-search</v-icon>
                                    Selecionar Paciente
                                </v-btn>
                                <div v-else class="container-paciente-evento elevation-1">
                                    <div class="container-nome-paciente">
                                        <div class="selecionado-label">
                                            <span class="primary--text font-weight-medium" style="font-size: 14px">Paciente Selecionado</span>
                                            <p class="text-h6 mb-0">{{ pacienteSelecionado.nome }}</p>
                                        </div>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon color="primary"
                                                       @click="abrirModalSelecionarPaciente">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            Alterar paciente
                                        </v-tooltip>
                                    </div>
                                    <v-divider class="my-2 w-100"></v-divider>
                                    <div class="container-info-paciente">
                                        <div class="selecionado-label">
                                            <span class="primary--text" style="font-size: 12px">CPF/CNPJ</span>
                                            <p class="mb-0">{{ pacienteSelecionado.cnpjCpf | formatarCpfCnpj }}</p>
                                        </div>
                                        <div class="selecionado-label ml-6">
                                            <span class="primary--text" style="font-size: 12px">Sexo</span>
                                            <p class="mb-0">{{ pacienteSelecionado.sexo }}</p>
                                        </div>
                                        <div class="selecionado-label ml-6">
                                            <span class="primary--text" style="font-size: 12px">Telefone</span>
                                            <p class="mb-0">{{ pacienteSelecionado.telefone | formatarTelefone }}</p>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-2 pb-0">
                                <v-btn v-if="!dentistaSelecionado" depressed block large color="primary"
                                       class="rounded-pill"
                                       @click="abrirModalSelecionarDentista">
                                    <v-icon left>mdi-tooth-outline</v-icon>
                                    Selecionar Dentista
                                </v-btn>
                                <div v-else class="container-dentista-evento elevation-1">
                                    <div class="container-foto-dentista">
                                        <foto-avatar :foto-url="dentistaSelecionado.foto"
                                                     class-avatar="imagem-dentista"/>
                                    </div>
                                    <div class="container-info-dentista">
                                        <div class="container-nome-dentista">
                                            <div class="selecionado-label">
                                                <span class="primary--text font-weight-medium" style="font-size: 14px">Dentista Selecionado</span>
                                                <p class="text-h6 mb-0">{{ dentistaSelecionado.nome }}</p>
                                            </div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" icon color="primary"
                                                           @click="abrirModalSelecionarDentista">
                                                        <v-icon>mdi-refresh</v-icon>
                                                    </v-btn>
                                                </template>
                                                Alterar dentista
                                            </v-tooltip>
                                        </div>
                                        <div class="container-sub-info-dentista mt-1">
                                            <label class="grey--text text--darken-1">{{
                                                    dentistaSelecionado.cargo
                                                }}</label>
                                            <div class="dentista-quadrado-cor ml-2"
                                                 :style="`--cor-dentista: ${dentistaSelecionado.corIdentificacao}`"/>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-switch
                        v-model="agendarAtendimento"
                        label="Agendar atendimento"
                        hide-details
                    />
                    <v-spacer/>
                    <v-btn @click="fecharModal" outlined>Cancelar</v-btn>
                    <v-btn @click="confirmarEvento" outlined class="ml-5">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment/moment'
import {actionTypes} from '@/core/constants'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'
import DateInputEvento from '@/views/components/DateInputEvento.vue'

export default {
    name: 'ModalAdicionarEventoAgenda',
    components: {DateInputEvento, PesquisaDentistaModal, FotoAvatar, PesquisaPacienteModal},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        dataInicio: {
            type: String,
            default: moment().format('YYYY-MM-DD HH:mm')
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 650
        }
    },
    data() {
        return {
            dadosGerais: {
                descricao: null,
                dataInicio: this.dataInicio,
                dataFim: null,
                dentistaId: null,
                consultorioId: null,
                pacienteId: null,
            },
            agendarAtendimento: false,
            duracaoEvento: 30,
            pacienteSelecionado: null,
            dentistaSelecionado: null,
            modalSelecionarPaciente: false,
            modalSelecionarDentista: false,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            this.model = false
            this.$emit('modalAdicionarEventoAcaoFechar')
        },
        fecharModalOutsideClick() {
            if (!this.persistencia) {
                this.fecharModal()
            }
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        selecionarPaciente(paciente) {
            this.pacienteSelecionado = paciente
            this.fecharModalSelecionarPaciente()
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        selecionarDentista(dentista) {
            this.dentistaSelecionado = dentista
            this.fecharModalSelecionarDentista()
        },
        async confirmarEvento() {
            if (this.isEventoValido()) {
                this.setMensagemLoading('Salvando evento na agenda...')
                const inputEvento = this.montarDadosGerais()
                await this.$store.dispatch(actionTypes.AGENDA.ADICIONAR_EVENTO, inputEvento)
                if (this.agendarAtendimento)
                    await this.criarAtendimentoAgendado(inputEvento)
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModal()
            }
        },
        async criarAtendimentoAgendado(input) {
            this.setMensagemLoading('Agendando atendimento...')
            await this.$store.dispatch(actionTypes.ATENDIMENTO.AGENDAR_ATENDIMENTO, input)
        },
        isEventoValido() {
            if (!this.dadosGerais.descricao || this.dadosGerais.descricao.length < 5) {
                this.mostrarNotificacaoErro('A descrição deve possuir no mínimo 5 caracteres!')
                return false
            }
            if (this.agendarAtendimento && (!this.pacienteSelecionado || !this.dentistaSelecionado)) {
                this.mostrarNotificacaoErro('Informe o paciente e o dentista para agendar um atendimento!')
                return false
            }
            return true
        },
        montarDadosGerais() {
            return {
                descricao: this.dadosGerais.descricao,
                dataInicio: moment(this.dadosGerais.dataInicio).format('YYYY-MM-DD HH:mm'),
                dataFim: moment(this.dadosGerais.dataInicio).add(this.duracaoEvento, 'm').format('YYYY-MM-DD HH:mm'),
                pacienteId: this.pacienteSelecionado ? this.pacienteSelecionado.id : null,
                dentistaId: this.dentistaSelecionado ? this.dentistaSelecionado.id : null,
            }
        },
        atualizarDuracaoEvento(duracao) {
            this.duracaoEvento = duracao
        },
        atualizarData(data) {
            this.dadosGerais.dataInicio = moment(data).format('YYYY-MM-DDTHH:mm:ss')
        },
    }
}

</script>

<style scoped lang="stylus">

.container-paciente-evento
    background-color #f8f9fa
    display flex
    flex-direction column
    justify-content center
    align-items flex-start
    padding 16px
    font-size 16px
    border-radius 12px
    border 1px solid #eee

.container-dentista-evento
    background-color #f8f9fa
    padding 16px
    font-size 16px
    border-radius 12px
    border 1px solid #eee
    display flex

.container-foto-dentista
    margin-right 16px

.container-info-dentista
    width 100%
    display flex
    flex-direction column

.container-nome-dentista
    width 100%
    display flex
    flex-direction row
    justify-content space-between

.container-sub-info-dentista
    display flex

.imagem-dentista
    height 90px
    width 90px
    border-radius 50%
    border 2px solid #eee

.container-nome-paciente
    width 100%
    display flex
    flex-direction row
    justify-content space-between

.container-info-paciente
    display flex
    margin-top 10px

.selecionado-label
    font-weight bold

    p
        color #5a5a5a

</style>